import React, { FC, useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { FormLayout } from '../../../shared/kiosk';
import { ExpressEditorComponentInner } from '../../containers/housekeeping/expressEditor';
import {
  KioskEditorConfiguration,
  OptionContextProps,
} from '../../containers/housekeeping/expressEditor/OptionContext';
import { useTranslation } from '../../translations';
import { Fetcher, useFetcher } from '../../utils';
import { captureError } from '../../utils/errorHandling';

const DealerFormEditorConfig: KioskEditorConfiguration = {
  multiplePages: false,
  allowCss: false,
  formTypes: ['markdown', 'divider', 'simpleLinkedTerms', 'dealerPii', 'dealerOption'],
};

export const DealerFormExpressEditor: FC = () => {
  const { ts } = useTranslation();
  const [config, setConfig] = useState<OptionContextProps>(() => ({
    config: DealerFormEditorConfig,
    options: [],
  }));

  const fetch = useFetcher(async () => {
    // Get dealer options
    const options = await api.getOptions('dealer');
    setConfig((old) => ({ ...old, options }));

    const pageLayout = await api.getDealerFormLayout();

    const defaultLayout: FormLayout = {
      finalPage: {
        id: 'final',
        name: 'Confirmation',
        sections: [],
      },
      footer: '',
      header: '',
      pages: [pageLayout],
      paymentOptions: {
        showPaymentScreen: true,
        markdown: '',
      },
      stylesheet: '',
      title: 'Express Editor for Dealers',
      disableBootstrap: false,
    };

    return { layout: defaultLayout };
  }, []);

  const save = useCallback(
    async (layout: FormLayout) => {
      const [firstPage] = layout.pages;
      if (!firstPage) {
        return;
      }

      try {
        await api.updateDealerFormLayout(firstPage);
        toast.success(ts('saved'));
      } catch (error) {
        captureError(error as Error);
      }
    },
    [ts],
  );

  if (!fetch.success) {
    return <Fetcher result={fetch} />;
  }

  return (
    <ExpressEditorComponentInner
      backLink="/housekeeping/dealers/settings"
      config={config}
      hideBeta
      initialLayout={fetch.data.layout}
      save={save}
    />
  );
};
